export const GroupPermissions = {
  GROUP_ADMIN: 'ADMIN',
  GROUP_MEMBER: 'MEMBER',
  GROUP_MODERATOR: 'MODERATOR',
};
